export class SelectedGMPQuote {
    constructor(
   public pensionFund: string = null,
   public startDate: string = null,
   public income: string= null,
   public indicative: string= null,
   public totalTaxFreeCashAmount: string = null,
   public taxFreeCashAmountPercent: string = null,
   public quoteExpiry: number = null,
   public monthlyIncome: number = null,
   public annualIncome: number = null,
   public padsRefNo: string= null,
   public paymentFrequency: string= null,
   public selectedProduct: string = null,
   public quoteRefNo: string = null,
   public productOptions: string = null,
   public requoteInd: string = null,
   public isGMP: string = null,
   public fundingSource: string = null,
   public applicationId: string = null) {
    }
}
